import axios from "./axios";

/**
 * 檢查駕照申請准入條件,並返回支付信息
 * @param {*} serviceType
 * @param {*} identType
 * @param {*} identNo
 * @param {*} licenseNo
 */
const check = (serviceType, identType, identNo, licenseNo, spNo, licenseType = "0") => {
  return axios
    .post(
      `/protected/api/v1/application/driving/${serviceType}?identType=${identType}&identNo=${identNo}${licenseNo ? `&licenseNo=${licenseNo}`:''}${spNo ? `&spNo=${spNo}`:''}${licenseNo ? `&licenseType=${licenseType}`:''}`
    )
    .then(res => res.data);
};

/**
 * 補交文件
 * @param {*} serviceType
 * @param {*} applicationId
 * @param {*} form
 */
const supplement = (serviceType, applicationId, form) => {
  return axios
    .post(
      `/protected/api/v1/application/driving/${serviceType}/${applicationId}/supplement`,
      form
    )
    .then(res => res.data);
};

/**
 * 根据申请编号获取详情
 * @param {*} applicationNo 
 * @returns 
 */
const getBySpNo = applicationNo => {
  return axios.get(`/protected/api/v1/application/driving/detail/${applicationNo}`).then(res => res.data);
}

/**
 * 查詢申領歷史記錄
 * @param {*} serviceType
 * @param {*} identType
 * @param {*} identNo
 */
const history = (serviceType, identType, identNo) => {
  return axios
    .post(
      `/protected/api/v1/application/driving/history/${serviceType}?identType=${identType}&identNo=${identNo}`
    )
    .then(res => res.data);
};

/**
 * 查詢國際駕照申請
 * @param {*} applicationId
 */
const getApplication = applicationId => {
  return axios
    .get(
      `/protected/api/v1/application/driving/international?applicationId=${applicationId}`
    )
    .then(res => res.data);
};

/**
 * 提交國際駕照申請
 * @param {*} form
 */
const application = (form, email = null) => {
  return axios
    .post(`/protected/api/v1/application/driving/international${email ? `?email=${email}`:''}`, form)
    .then(res => res.data);
};

/**
 * 獲取通知訊息
 * @param {*} id
 * @param {*} serviceType
 * @param {*} messageType
 * @param {*} parameters
 */
const message = (id, serviceType, messageType, parameters = {}) => {
  return axios
    .post(
      `/protected/api/v1/application/driving/preview-message?serviceType=${serviceType}&messageType=${messageType}${
        id ? `&id=${id}` : ""
      }`,
      parameters
    )
    .then(res => res.data);
};

/**
 * 下載一寸半彩照
 * @param {*} photoNo 
 * @returns 
 */
const photo = photoNo => {
  return axios.post(`/protected/api/v1/application/driving/photo/${photoNo}`, null, {
    responseType: 'arraybuffer'
  }).then(res => res.data)
}

export default {
  check,
  supplement,
  history,
  getApplication,
  application,
  message,
  getBySpNo,
  photo
};